export const GET_CONTENTFUL_PAGE = 'GET_CONTENTFUL_PAGE';
export const GET_CONTENTFUL_PAGE_SUCCESS = 'GET_CONTENTFUL_PAGE_SUCCESS';
export const GET_CONTENTFUL_PAGE_ERROR = 'GET_CONTENTFUL_PAGE_ERROR';
